import TaskOwnershipTable from "../../../../src/components/TaskOwnershipTable";
import * as React from 'react';
export default {
  TaskOwnershipTable,
  React
};